import {
  getAppliesIntegrationSection,
  type AppliesIntegrationSectionProps,
} from "./integrationSections";

/**
 * Renders the section every integration with an active applies module has registered for this apply, in
 * the order the apply reports them.
 */
export function AppliesIntegrationSections({ apply }: AppliesIntegrationSectionProps) {
  return (
    <>
      {apply.appliesModules?.map((integrationName) => {
        const Section = getAppliesIntegrationSection(integrationName);
        if (!Section) return null;

        return <Section key={integrationName} apply={apply} />;
      })}
    </>
  );
}
